<template>
  <div class="VirtualReg">
      <div class="content">
        <div class="dse">点击导航时直接跳转zc.510jl.com，本网站不做模拟注册</div>
        <!-- <iframe  ref="iframe" src="https://zc.510jl.com/siteMap/index.html" frameborder="0"></iframe> -->
        <!-- <div class="ges" @click="goGuide()">亚马逊注册使用指南</div> -->
      </div>
      <div class="pop_bg" v-if="isPop"></div>
      <div class="selectPop" v-if="isPop">
        <div class="tit">北美站模拟注册模式选择</div>
        <div class="ico" @click="isPop=false">×</div>
        <div class="ul">
          <div class="list" v-for="(item,index) in conts" :key="index" :class="{avt:indexs==index}"  @click="setOp(index)">
            <div class="icon"></div>
            <div class="cont">
              <div class="titles">
                {{item.name}}
              </div>
              <div class="dev">{{item.dev}}</div>
            </div>
          </div>
        </div>
        <div class="btn" @click="goUS()">开始模拟</div>
      </div>
  </div>
</template>
<script>

export default {
  name: "VirtualReg",
  data: function() {
    return {
      isPop:false,
      indexs:1,
      conts:[{name:'招商经理模式 模拟注册',dev:'通过亚马逊网站自行注册'},
             {name:'自注册模式 模拟注册',dev:'通过亚马逊网站自行注册'}],
      list:[
        {
          imgs:require("../../assets/images/home/icon_US.png"),
          name:'美国站'
        },
         {
          imgs:require("../../assets/images/home/icon_EU.png"),
          name:'欧洲站'
        },
         {
          imgs:require("../../assets/images/home/icon_JP.png"),
          name:'日本站'
        },
         {
          imgs:require("../../assets/images/home/icon_AU.png"),
          name:'澳洲站'
        },
         {
          imgs:require("../../assets/images/home/icon_AE.png"),
          name:'阿联酋站'
        },
         {
          imgs:require("../../assets/images/home/icon_SG.png"),
          name:'新加坡站'
        },
        {
          imgs:require("../../assets/images/home/icon_IN.png"),
          name:'印度站'
        },
      ]  
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
	}
  },
  
  components: {
  },
  mounted () {
     window.addEventListener('message', event => {
            // 根据上面制定的结构来解析iframe内部发回来的数据
          const data = event.data
          try { 
            if(data.site){
                if(data.site=='us'){
                  if(this.user.username){
                    //  location.replace('');
                     window.open(this.interfaceJson.localUrl+'siteUs',true) 
                    // this.isPop=true
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }else if(data.site=='eu'){
                  if(this.user.username){
                    //  this.$message({
                    //       message: "该站点正在维护！敬请期待",
                    //       type: "error"
                    //   });
                    window.open(this.interfaceJson.localUrl+'siteUk',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                else if(data.site=='au'){
                  if(this.user.username){
                    // this.goLinks('/siteUs')
                    window.open(this.interfaceJson.localUrl+'siteAu',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                else if(data.site=='jp'){
                  if(this.user.username){
                    // this.goLinks('/siteUs')
                    window.open(this.interfaceJson.localUrl+'siteJp',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                 else if(data.site=='ae'){
                  if(this.user.username){
                    // this.goLinks('/siteUs')
                    window.open(this.interfaceJson.localUrl+'siteAe',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                 else if(data.site=='sg'){
                  if(this.user.username){
                    // this.goLinks('/siteUs')
                    window.open(this.interfaceJson.localUrl+'siteSg',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                 else if(data.site=='in'){
                  if(this.user.username){
                    // this.goLinks('/siteUs')
                    window.open(this.interfaceJson.localUrl+'siteIn',true)  
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
                else{
                  if(this.user.username){
                      this.$message({
                          message: "该站点暂未开通！敬请期待",
                          type: "error"
                      });
                  }else{
                    this.$store.dispatch("loginState",{isShowLogin:true}); 
                  }
                }
              }
            }catch(err) {
        }
          
        });
        this.iframeWin = this.$refs.iframe.contentWindow;  
    },
  methods: {
    goUS(){
      if(this.indexs==1){
        window.open(this.interfaceJson.localUrl+'SiteNewUs',true) 
      }else{
        window.open(this.interfaceJson.localUrl+'siteUs',true) 
      }
    },
    setOp(e){
      this.indexs=e
    },
    goGuide(){
		     window.open(this.interfaceJson.ipUrl+'/guide/guide.html') 	
	  },
    gosite(e){
      if(e==0){
        if(this.user.username){
          // this.goLinks('/siteUs')
          window.open(this.interfaceJson.localUrl+'siteUs',true)  
        }else{
          this.$store.dispatch("loginState",{isShowLogin:true}); 
        }
      }else if(e==1){

      }
      else{
        if(this.user.username){
           	this.$message({
                message: "该站点暂未开通！敬请期待",
                type: "error"
			      });
        }else{
          this.$store.dispatch("loginState",{isShowLogin:true}); 
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// 评分弹窗
.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #fff;
    opacity: .5;
}
.selectPop{
  position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  width:400px;
  height:309px;
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 25px;
  .tit{
    font-size: 14px;
    color: #000000;
    height: 20px;
    margin-top: 21px;
    text-align: center;
    position: relative;
  }
  .ico{
    color: #333333;
    font-size: 30px;
    position: absolute;
    right: 13px;
    top: 5px;
    cursor: pointer;
  }
  .ul{
    margin-top: 18px;
    .list{
      cursor: pointer;
      width: 334px;
      height: 77px;
      background: #FFFFFF;
      border: 1px solid #E8E8E8;
      display: flex;
      margin-bottom: 20px;
      .icon{
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        border-radius: 50%;
        margin-left: 40px;
        margin-top: 20px;
        cursor: pointer;
        position: relative;
      }
      .cont{
        margin-top: 16px;
        margin-left: 21px;
        .titles{
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 25px;
          color: #232F3E;
        }
        .dev{
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          color: #232F3E;
        }
      }
    }
    .avt{
      border: 1px solid #178AFF;
      .icon::after{
        content: '';
        position: absolute;
        width: 12px;
        left: 2px;
        top: 2px;
        height: 12px;
        background: #178AFF;
        border-radius: 50%;
      }
    }
  }
  .btn{
    width: 110px;
    height: 32px;
    background: #F3CD70;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    margin: 0 auto;
    cursor: pointer;
  }
}
.ifem{
  width: 500px;
  height: 200px;
}
.Home{
  background-color: #232F3E;
}
.content{
  // padding-top: 42px ;
  margin: 0 auto;
  box-sizing: border-box;
  // padding: 42px 24px 0 24px;
  background-color: #ffffff;
  text-align: center;
  .dse{
    display: inline-block;
    margin-top: 50px;
  }
}
// .content iframe{
//   width: 100%;
//   height: 696.6px;
// }
.ges{
  width:152px;
  height:35px;
  background:rgba(255,255,255,1);
  opacity:1;
  border-radius:20px 0px 0px 20px;
  text-align: center;
  line-height: 35px;
  position: fixed;
  z-index: 999999;
  right: 0;
  top: 165px;
  color: #178AFF;
  font-size:14px;
  cursor: pointer;
}
.siteWrap {
  display: flex;
}
.siteWrap .siteUl{
  display: flex;
  flex-wrap:wrap ;
  width: 100%;
}
.siteWrap .siteUl .siteLi{
  margin-right: 2%;
  margin-bottom: 20px;
  width: 18.4%;
  transition-duration: .3s;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.64, 0.15, 0.53, 0.53);
  cursor: pointer;
   background-color: #232F3E;
}
.siteWrap .siteUl .siteLi:hover{
    transform: scale(1.05);
}
.siteWrap .siteUl .siteLi:nth-child(5n-0){
  margin-right: 0px;
}
.siteWrap .siteUl .siteLi .icon{
  height: 128px;
  text-align: center;
}
.siteWrap .siteUl .siteLi .icon img{
  width: 96px;
  height: 96px;
  padding-top: 26px;
}
.siteWrap .siteUl .siteLi .name{
  color: #FFFFFF;
  background-color: #2F3A48;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
@media screen and (max-width: 1380px) {
  .siteWrap .siteUl .siteLi:nth-child(4n-0){
     margin-right:0px;
  }
    .siteWrap .siteUl .siteLi:nth-child(5n-0){
     margin-right:2%;
  }
  .siteWrap .siteUl .siteLi{
    margin-right: 2%;
    margin-bottom: 20px;
    width: 23.5%;
  }
}

</style>
<style >
  .Home .el-carousel__container  {
    height: 580px;
  }
</style>